import { PageMetaType } from '@shared/api/server/base'

export class PaginatedResponse<T> {
  public data: T
  public meta: PageMetaType

  constructor(data: T, meta: PageMetaType) {
    this.data = data
    this.meta = meta
  }

  public hasNextPage(): boolean {
    return this.meta.page * this.meta.size < this.meta.total
  }
  public currentPage(): number {
    return this.meta.page
  }
  public pageCount(): number {
    return Math.ceil(this.meta.total / this.meta.size)
  }
}
